(function () {
  var h = document.querySelector('.site-header');
  if (!h) return;
  var isHome = document.body.classList.contains('template-index');
  var lastY = window.scrollY, ticking = false, DELTA = 6;
  h.classList.add('mz-smart');
  function setH() { document.documentElement.style.setProperty('--mz-header-h', h.offsetHeight + 'px'); }
  function menuOpen() {
    var t = h.querySelector('.js-mobile-nav-toggle');
    return !!t && (t.getAttribute('aria-expanded') === 'true' || t.classList.contains('mobile-nav--close'));
  }
  function update() {
    ticking = false;
    var y = Math.max(window.scrollY, 0), hh = h.offsetHeight;
    if (isHome || menuOpen() || y <= hh) { h.classList.remove('mz-hidden'); }
    else if (Math.abs(y - lastY) > DELTA) { h.classList.toggle('mz-hidden', y > lastY); }
    lastY = y;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  window.addEventListener('resize', setH, { passive: true });
  h.addEventListener('click', function (e) {
    if (e.target.closest('.js-mobile-nav-toggle')) { h.classList.remove('mz-hidden'); setTimeout(update, 50); }
  });
  setH(); update();
})();